import { Box, Text } from '@chakra-ui/react';
import ViewScheduleSlot from './ViewScheduleSlot';

export default function ViewScheduleRow({ session, time, id }) {
console.log(session,"session");
  return (
    <Box
      width='100%'
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      mb='1rem'
      
    >
      <Box
        flex='1'
        display='flex'
        height='100px'
        justifyContent='center'
        alignItems='center'
        color='#F25C3A'
        style={{ fontFamily: 'Mulish, sans-serif' }}
      >
        <Text
          fontFamily='Poppins'
          fontStyle='normal'
          fontWeight='bold'
          fontSize='12px'
          lineHeight='18px'
          color='black'
          style={{ fontFamily: 'Mulish, sans-serif'  }}
        >
          {time}
        </Text>
      </Box>
      {session.map((row, idx) => (
        <ViewScheduleSlot
          key={idx}
          subject={row ? row.subject_name : null}
          className={row ? row.class_name : null}
          categoryId={row ? row.category_id : null}
          time={time}
          libraryTitle={row ? row.library_title : null}
          categoryTitle ={row ? row.category_title : null}
          contentUrl={row ? row.library_url : null}
          tutorName={row ? row.tutor_name : null}
        />
      ))}
    </Box>
  );
}
